import {defineMessage} from 'react-intl';
import * as React from 'react';
import {setup, run} from '../../snippets/php';
import comment from '../../snippets/comment';
import {CreateShellCommand} from '../../../components/left-col';

export const steps = {
  setup,
  create: {},
  customer: {},
  'pass-customer': {},
  charge: {},
  'run-server': {
    body: {
      message: defineMessage({
        id: 'docsApp.ib.aap.server.php.run-server.body',
        defaultMessage:
          'Run your server and go to <a>localhost:4242/checkout.html</a>.',
      }),
      values: {
        a: (str) => (
          <a href="http://localhost:4242/checkout.html" target="_blank">
            {str}
          </a>
        ),
      },
    },
    Component: CreateShellCommand(run),
  },
};

export default ({keys, merchant}) => `<?php

require 'vendor/autoload.php';

{+setup}
${comment && comment(merchant)}
\\Stripe\\Stripe::setApiKey('${keys.secret}');
{/setup}


function calculateOrderAmount(array $items): int {
  // Replace this constant with a calculation of the order's amount
  // Calculate the order total on the server to prevent
  // customers from directly manipulating the amount on the client
  return 1400;
}

header('Content-Type: application/json');

try {
  // retrieve JSON from POST body
  $json_str = file_get_contents('php://input');
  $json_obj = json_decode($json_str);

  {?save-card customer}
  // Alternatively, set up a webhook to listen for the payment_intent.succeeded event
  // and attach the PaymentMethod to a new Customer
  $customer = \\Stripe\\Customer::create();
  {/customer}
  {+create}
  {span response create}$paymentIntent{/span} = \\Stripe\\PaymentIntent::create([
    'amount' => calculateOrderAmount($json_obj->items),
    'currency' => 'usd',
    {?save-card pass-customer}
    'customer' => $customer->id,
    'setup_future_usage' => 'off_session',
    {/pass-customer}
  ]);

  $output = [
    'clientSecret' => $paymentIntent->client_secret,
  ];
  {/create}

  echo json_encode($output);
} catch (Error $e) {
  http_response_code(500);
  echo json_encode(['error' => $e->getMessage()]);
}`;
